webpackJsonp([9708813733672],{

/***/ 632:
/***/ (function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }),

/***/ 133:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Title = __webpack_require__(7);
	
	var _CardGrid = __webpack_require__(104);
	
	__webpack_require__(133);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var nArtistsPerRow = 4;
	
	var ArtistGrid = function (_Component) {
	  _inherits(ArtistGrid, _Component);
	
	  function ArtistGrid() {
	    _classCallCheck(this, ArtistGrid);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ArtistGrid.prototype.render = function render() {
	    var data = this.props.data;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Title.Title, { name: data.title }),
	      _react2.default.createElement(_CardGrid.CardGrid, {
	        nCellsPerRow: nArtistsPerRow,
	        data: data.artists,
	        sizes: this.props.sizes,
	        isShort: this.props.isShort
	      })
	    );
	  };
	
	  return ArtistGrid;
	}(_react.Component);
	
	exports.default = { ArtistGrid: ArtistGrid };
	module.exports = exports['default'];

/***/ }),

/***/ 404:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(33);
	
	var _LinkBoxGrid = __webpack_require__(288);
	
	__webpack_require__(404);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AuditionExcerpts = function (_Component) {
	  _inherits(AuditionExcerpts, _Component);
	
	  function AuditionExcerpts() {
	    _classCallCheck(this, AuditionExcerpts);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  AuditionExcerpts.prototype.render = function render() {
	    var description = (0, _utils.renderParagraphs)(this.props.description);
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'subtitle' },
	        this.props.title
	      ),
	      description,
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(_LinkBoxGrid.LinkBoxGrid, { data: this.props.excerpts, nCellsPerRow: 3 })
	    );
	  };
	
	  return AuditionExcerpts;
	}(_react.Component);
	
	exports.default = { AuditionExcerpts: AuditionExcerpts };
	module.exports = exports['default'];

/***/ }),

/***/ 67:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyImage = __webpack_require__(18);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	__webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Card = function (_Component) {
	  _inherits(Card, _Component);
	
	  function Card() {
	    _classCallCheck(this, Card);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Card.prototype.render = function render() {
	    var data = this.props.data;
	    var img = _react2.default.createElement(_gatsbyImage2.default, { className: 'card-img', sizes: this.props.sizes });
	    var cardImg = data.isClickable ? _react2.default.createElement(
	      'a',
	      { target: '_blank', href: data.href },
	      img
	    ) : _react2.default.createElement(
	      'div',
	      null,
	      img
	    );
	
	    return _react2.default.createElement(
	      'div',
	      { className: "card" + (this.props.isShort ? " short" : " tall") },
	      cardImg,
	      _react2.default.createElement(
	        'div',
	        { className: 'card-content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-name' },
	          data.name
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-info' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-info-block' },
	            _react2.default.createElement(
	              'div',
	              { style: { lineHeight: 1.5 } },
	              data.position
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card-info-block' },
	            _react2.default.createElement(
	              'div',
	              { style: { lineHeight: 1.5 } },
	              data.affiliation
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card-info-block' },
	            _react2.default.createElement(
	              'div',
	              { style: { lineHeight: 1.5 } },
	              data.affiliate_position
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Card;
	}(_react.Component);
	
	exports.default = { Card: Card };
	module.exports = exports['default'];

/***/ }),

/***/ 134:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Card = __webpack_require__(30);
	
	var _Title = __webpack_require__(7);
	
	var _Grid = __webpack_require__(19);
	
	__webpack_require__(134);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var nCellsPerRowMobile = 1;
	var nCellsPerRow = 4;
	
	var CardGrid = function (_Component) {
	  _inherits(CardGrid, _Component);
	
	  function CardGrid() {
	    _classCallCheck(this, CardGrid);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  CardGrid.prototype.render = function render() {
	    var _this2 = this;
	
	    var cards = this.props.data.map(function (datum, index) {
	      return _react2.default.createElement(_Card.Card, {
	        height: _this2.props.height,
	        isShort: _this2.props.isShort,
	        data: datum, sizes: _this2.props.sizes[index] });
	    });
	
	    return _react2.default.createElement(_Grid.Grid, {
	      data: cards,
	      nCellsPerRow: nCellsPerRow,
	      nCellsPerRowMobile: nCellsPerRowMobile
	    });
	  };
	
	  return CardGrid;
	}(_react.Component);
	
	exports.default = { CardGrid: CardGrid };
	module.exports = exports['default'];

/***/ }),

/***/ 135:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Title = __webpack_require__(7);
	
	var _InfoBlockGrid = __webpack_require__(21);
	
	__webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var nArtistsPerRow = 3;
	var nArtistsPerRowMobile = 1;
	
	var FeaturedArtists = function (_Component) {
	  _inherits(FeaturedArtists, _Component);
	
	  function FeaturedArtists() {
	    _classCallCheck(this, FeaturedArtists);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  FeaturedArtists.prototype.render = function render() {
	    var data = this.props.data;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Title.Title, { name: data.title }),
	      _react2.default.createElement(_InfoBlockGrid.InfoBlockGrid, {
	        nCellsPerRow: nArtistsPerRow,
	        nCellsPerRowMobile: nArtistsPerRowMobile,
	        data: data.artists,
	        sizes: this.props.sizes })
	    );
	  };
	
	  return FeaturedArtists;
	}(_react.Component);
	
	exports.default = { FeaturedArtists: FeaturedArtists };
	module.exports = exports['default'];

/***/ }),

/***/ 68:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Card = __webpack_require__(30);
	
	var _Title = __webpack_require__(7);
	
	__webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var desktopWidth = 720;
	var defaultMargin = 33;
	var mobilePadding = 21;
	
	var Grid = function (_Component) {
	  _inherits(Grid, _Component);
	
	  function Grid(props) {
	    _classCallCheck(this, Grid);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      width: desktopWidth
	    };
	
	    _this.updateWidth = _this.updateWidth.bind(_this);
	    return _this;
	  }
	
	  Grid.prototype.componentDidMount = function componentDidMount() {
	    this.updateWidth();
	    if (typeof window !== 'undefined') {
	      window.addEventListener('resize', this.updateWidth);
	    }
	  };
	
	  Grid.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (typeof window !== 'undefined') {
	      window.removeEventListener('resize', this.updateWidth);
	    }
	  };
	
	  Grid.prototype.updateWidth = function updateWidth() {
	    if (typeof window !== 'undefined') {
	      this.setState({ width: window.innerWidth < desktopWidth ? window.innerWidth - 2 * mobilePadding : desktopWidth });
	    }
	  };
	
	  Grid.prototype.renderRows = function renderRows(array, nCellsPerRow, marginTop, marginLeft) {
	    var _this2 = this;
	
	    var chunks = this.chunkByRows(array, nCellsPerRow);
	    return chunks.map(function (chunk, index) {
	      return _react2.default.createElement(
	        'div',
	        { key: index, className: 'row', style: { marginTop: index == 0 ? 0 : marginTop } },
	        _this2.renderRow(chunk, nCellsPerRow, marginLeft)
	      );
	    });
	  };
	
	  Grid.prototype.chunkByRows = function chunkByRows(array, nCellsPerRow) {
	    var chunkedArray = [];
	    var len = array.length;
	    for (var i = 0; i < len; i += nCellsPerRow) {
	      chunkedArray.push(array.slice(i, i + nCellsPerRow));
	    }
	
	    return chunkedArray;
	  };
	
	  Grid.prototype.computeCellWidth = function computeCellWidth(totalWidth, nCells, marginLeft) {
	    return (totalWidth - (nCells - 1) * marginLeft) / nCells;
	  };
	
	  Grid.prototype.renderRow = function renderRow(row, nCellsPerRow, marginLeft) {
	    var width = this.computeCellWidth(this.state.width, nCellsPerRow, marginLeft);
	    var cells = row.map(function (cell, index) {
	      var margin = index === 0 ? 0 : marginLeft;
	      return _react2.default.createElement(
	        'div',
	        { key: index, style: { width: width, marginLeft: margin }, className: 'cell' },
	        cell
	      );
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      ' ',
	      cells,
	      ' '
	    );
	  };
	
	  Grid.prototype.render = function render() {
	    var marginLeft = this.props.marginLeft ? this.props.marginLeft : defaultMargin;
	    var marginTop = this.props.marginTop ? this.props.marginTop : marginLeft;
	    var nCellsPerRow = this.state.width < desktopWidth ? this.props.nCellsPerRowMobile : this.props.nCellsPerRow;
	    var rows = this.renderRows(this.props.data, nCellsPerRow, marginTop, marginLeft);
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      rows
	    );
	  };
	
	  return Grid;
	}(_react.Component);
	
	exports.default = { Grid: Grid };
	module.exports = exports['default'];

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InfoBlock = __webpack_require__(37);
	
	var _Title = __webpack_require__(7);
	
	var _Grid = __webpack_require__(19);
	
	__webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var nCellsPerRowMobile = 1;
	
	var InfoBlockGrid = function (_Component) {
	  _inherits(InfoBlockGrid, _Component);
	
	  function InfoBlockGrid() {
	    _classCallCheck(this, InfoBlockGrid);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  InfoBlockGrid.prototype.render = function render() {
	    var _this2 = this;
	
	    var title = this.props.title ? _react2.default.createElement(_Title.Title, { name: this.props.title }) : null;
	    var sizes = this.props.sizes;
	
	    var data = this.props.data.map(function (datum, index) {
	      return _react2.default.createElement(_InfoBlock.InfoBlock, {
	        descriptionStyleMod: _this2.props.descriptionStyleMod ? _this2.props.descriptionStyleMod : {},
	        containsImage: true,
	        hasModalImage: _this2.props.hasModalImage,
	        data: datum,
	        sizes: sizes[index] });
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      title,
	      _react2.default.createElement(_Grid.Grid, {
	        marginTop: 50,
	        data: data,
	        nCellsPerRow: this.props.nCellsPerRow,
	        nCellsPerRowMobile: this.props.nCellsPerRowMobile })
	    );
	  };
	
	  return InfoBlockGrid;
	}(_react.Component);
	
	exports.default = { InfoBlockGrid: InfoBlockGrid };
	module.exports = exports['default'];

/***/ }),

/***/ 69:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Title = __webpack_require__(7);
	
	var _Paragraph = __webpack_require__(32);
	
	var _InfoBlock = __webpack_require__(37);
	
	var _utils = __webpack_require__(33);
	
	var _gatsbyImage = __webpack_require__(18);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	__webpack_require__(70);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfoSection = function (_Component) {
	  _inherits(InfoSection, _Component);
	
	  function InfoSection() {
	    _classCallCheck(this, InfoSection);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  InfoSection.prototype.render = function render() {
	    var img = this.props.sizes ? _react2.default.createElement(_gatsbyImage2.default, { sizes: this.props.sizes }) : _react2.default.createElement('div', { style: { marginTop: -30 } });
	    var description = (0, _utils.renderParagraphs)(this.props.description);
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Title.Title, { name: this.props.title }),
	      img,
	      _react2.default.createElement('br', null),
	      description
	    );
	  };
	
	  return InfoSection;
	}(_react.Component);
	
	exports.default = { InfoSection: InfoSection };
	module.exports = exports['default'];

/***/ }),

/***/ 70:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LinkBox = function (_Component) {
	  _inherits(LinkBox, _Component);
	
	  function LinkBox() {
	    _classCallCheck(this, LinkBox);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  LinkBox.prototype.render = function render() {
	    var data = this.props.data;
	
	    var style = this.props.fixedWidth ? { width: this.props.fixedWidth } : {};
	
	    return _react2.default.createElement(
	      'div',
	      { style: { textAlign: 'center' } },
	      _react2.default.createElement(
	        'a',
	        { style: style, className: 'link-box', href: data.href, target: '_blank' },
	        data.text
	      )
	    );
	  };
	
	  return LinkBox;
	}(_react.Component);
	
	exports.default = { LinkBox: LinkBox };
	module.exports = exports['default'];

/***/ }),

/***/ 71:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LinkBox = __webpack_require__(38);
	
	var _Title = __webpack_require__(7);
	
	var _Grid = __webpack_require__(19);
	
	__webpack_require__(416);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var nCellsPerRowMobile = 2;
	
	var LinkBoxGrid = function (_Component) {
	  _inherits(LinkBoxGrid, _Component);
	
	  function LinkBoxGrid() {
	    _classCallCheck(this, LinkBoxGrid);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  LinkBoxGrid.prototype.render = function render() {
	    var data = this.props.data.map(function (datum, index) {
	      return _react2.default.createElement(_LinkBox.LinkBox, { fixedWidth: '100%', data: datum });
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Grid.Grid, {
	        marginTop: 33,
	        data: data,
	        nCellsPerRow: this.props.nCellsPerRow,
	        nCellsPerRowMobile: nCellsPerRowMobile })
	    );
	  };
	
	  return LinkBoxGrid;
	}(_react.Component);
	
	exports.default = { LinkBoxGrid: LinkBoxGrid };
	module.exports = exports['default'];

/***/ }),

/***/ 416:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Title = __webpack_require__(7);
	
	var _InfoBlockGrid = __webpack_require__(21);
	
	__webpack_require__(137);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var nBlocksPerRow = 2;
	var nBlocksPerRowMobile = 1;
	
	var OverviewBlocks = function (_Component) {
	  _inherits(OverviewBlocks, _Component);
	
	  function OverviewBlocks() {
	    _classCallCheck(this, OverviewBlocks);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  OverviewBlocks.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_InfoBlockGrid.InfoBlockGrid, {
	        nCellsPerRowMobile: nBlocksPerRowMobile,
	        nCellsPerRow: nBlocksPerRow,
	        data: this.props.blocks,
	        sizes: this.props.sizes
	      })
	    );
	  };
	
	  return OverviewBlocks;
	}(_react.Component);
	
	exports.default = { OverviewBlocks: OverviewBlocks };
	module.exports = exports['default'];

/***/ }),

/***/ 137:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _signupForm = __webpack_require__(294);
	
	__webpack_require__(422);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Signup = function (_Component) {
	  _inherits(Signup, _Component);
	
	  function Signup() {
	    _classCallCheck(this, Signup);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Signup.prototype.render = function render() {
	    var data = this.props.data;
	    var instruction = data.instruction ? data.instruction : null;
	
	    return _react2.default.createElement(
	      'div',
	      { style: { marginTop: "-5" } },
	      _react2.default.createElement(
	        'div',
	        { className: 'signup-bulletin' },
	        _react2.default.createElement(
	          'em',
	          null,
	          ' ',
	          instruction,
	          ' '
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { paddingBottom: '30px' } },
	        _react2.default.createElement(_signupForm.SignupForm, { data: data.form })
	      )
	    );
	  };
	
	  return Signup;
	}(_react.Component);
	
	exports.default = { Signup: Signup };
	module.exports = exports['default'];

/***/ }),

/***/ 421:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(632);
	
	__webpack_require__(421);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var url = "https://script.google.com/macros/s/AKfycbyzdDh9uXauvfjBSBkTiOOYoX_-uFQzHoUFTC6srw30AkVhlLE/exec";
	var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	var SignupForm = function (_Component) {
	  _inherits(SignupForm, _Component);
	
	  function SignupForm(props) {
	    _classCallCheck(this, SignupForm);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      isFormPending: false,
	      isFormSubmitted: false,
	      isFormValid: false,
	      isFirstNamePresent: false,
	      isLastNamePresent: false,
	      isEmailPresent: false,
	      isEmailValid: false
	    };
	
	    _this.validateAndSubmit = _this.validateAndSubmit.bind(_this);
	    _this.validateForm = _this.validateForm.bind(_this);
	    _this.formSubmit = _this.formSubmit.bind(_this);
	    return _this;
	  }
	
	  SignupForm.prototype.validateAndSubmit = function validateAndSubmit(e) {
	    e.preventDefault();
	
	    var isInvalid = !this.validateForm();
	
	    if (isInvalid) {
	      return;
	    }
	
	    this.formSubmit();
	  };
	
	  SignupForm.prototype.validateForm = function validateForm() {
	    var isFirstNameValid = this.validateFirstName();
	    var isLastNameValid = this.validateLastName();
	    var isEmailValid = this.validateEmail();
	
	    var isFormValid = isFirstNameValid && isLastNameValid && isEmailValid;
	
	    this.setState({ isFormInvalid: !isFormValid });
	
	    return isFormValid;
	  };
	
	  SignupForm.prototype.generateFormQueryString = function generateFormQueryString() {
	    var formParams = { first_name: this.firstNameRef.value,
	      last_name: this.lastNameRef.value,
	      email_address: this.emailRef.value };
	
	    var esc = encodeURIComponent;
	
	    var query = Object.keys(formParams).map(function (k) {
	      return esc(k) + '=' + esc(formParams[k]);
	    }).join('&');
	
	    return '?' + query;
	  };
	
	  SignupForm.prototype.formSubmit = function formSubmit() {
	    this.setState({ isPending: true });
	    var queryString = this.generateFormQueryString();
	
	    fetch(url + queryString, {
	      method: "GET",
	      mode: 'no-cors',
	      credentials: 'include'
	    }).then(function (response) {
	      console.log(response);
	      this.setState({ isFormSubmitted: true, isFormPending: false });
	    }.bind(this)).catch(function (error) {
	      console.log(error);
	      alert('Error occured');
	    });
	  };
	
	  SignupForm.prototype.validateFirstName = function validateFirstName() {
	    var isFirstNamePresent = this.firstNameRef.value != '';
	    this.setState({ isFirstNamePresent: isFirstNamePresent });
	    return isFirstNamePresent;
	  };
	
	  SignupForm.prototype.validateLastName = function validateLastName() {
	    var isLastNamePresent = this.lastNameRef.value != '';
	    this.setState({ isLastNamePresent: isLastNamePresent });
	    return isLastNamePresent;
	  };
	
	  SignupForm.prototype.validateEmail = function validateEmail() {
	    var isEmailPresent = this.emailRef.value != '';
	    var isEmailValid = emailRegex.test(this.emailRef.value);
	    this.setState({ isEmailPresent: isEmailPresent });
	    this.setState({ isEmailValid: isEmailValid });
	    return isEmailPresent && isEmailValid;
	  };
	
	  SignupForm.prototype.generateErrorMessage = function generateErrorMessage(condition, text) {
	    var shouldDisplayErrorMessages = this.state.isFormInvalid;
	    return _react2.default.createElement(
	      'div',
	      { className: 'invalid-message-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'invalid-message-signup', style: { display: condition && shouldDisplayErrorMessages ? 'inline-block' : 'none' } },
	        text
	      )
	    );
	  };
	
	  SignupForm.prototype.render = function render() {
	    var _this2 = this;
	
	    var data = this.props.data;
	    var _state = this.state,
	        isFormPending = _state.isFormPending,
	        isFormSubmitted = _state.isFormSubmitted,
	        isFormInvalid = _state.isFormInvalid,
	        isFirstNamePresent = _state.isFirstNamePresent,
	        isLastNamePresent = _state.isLastNamePresent,
	        isEmailPresent = _state.isEmailPresent,
	        isEmailValid = _state.isEmailValid;
	
	    console.log(data.submissionMessage);
	
	    if (isFormSubmitted) {
	      return _react2.default.createElement(
	        'div',
	        { style: { fontSize: '14' }, className: 'center form-container' },
	        data.submissionMessage
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'form-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'form-title' },
	        data.title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'form-instruction' },
	        data.instruction
	      ),
	      _react2.default.createElement(
	        'form',
	        { style: { marginBottom: 0 }, onSubmit: this.validateAndSubmit.bind(this) },
	        this.generateErrorMessage(!isFirstNamePresent && !isLastNamePresent, data.missingFirstAndLastNameMsg),
	        this.generateErrorMessage(!isFirstNamePresent && isLastNamePresent, data.missingFirstNameMsg),
	        this.generateErrorMessage(isFirstNamePresent && !isLastNamePresent, data.missingLastNameMsg),
	        _react2.default.createElement(
	          'div',
	          { className: 'center name-container' },
	          _react2.default.createElement('input', {
	            type: 'text',
	            name: 'first_name',
	            className: 'signup-form-elem',
	            placeholder: data.firstName,
	            ref: function ref(input) {
	              return _this2.firstNameRef = input;
	            } }),
	          _react2.default.createElement('input', {
	            type: 'text',
	            name: 'last_name',
	            className: 'signup-form-elem',
	            placeholder: data.lastName,
	            ref: function ref(input) {
	              return _this2.lastNameRef = input;
	            } })
	        ),
	        this.generateErrorMessage(!isEmailPresent, data.missingEmailMsg),
	        this.generateErrorMessage(isEmailPresent && !isEmailValid, data.invalidEmailMsg),
	        _react2.default.createElement(
	          'div',
	          { style: { paddingBottom: 10 }, className: 'center', onClick: function onClick() {
	              return _this2.emailRef.focus();
	            } },
	          _react2.default.createElement('input', {
	            id: 'email',
	            name: 'email_address',
	            type: 'text',
	            className: 'signup-form-elem',
	            placeholder: data.email,
	            ref: function ref(input) {
	              return _this2.emailRef = input;
	            } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { paddingTop: 10 }, className: 'center' },
	          _react2.default.createElement(
	            'button',
	            { className: 'signup-submit-button' },
	            data.submit
	          )
	        )
	      )
	    );
	  };
	
	  return SignupForm;
	}(_react.Component);
	
	exports.default = { SignupForm: SignupForm };
	module.exports = exports['default'];

/***/ }),

/***/ 422:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 428:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Header = __webpack_require__(31);
	
	var _Footer = __webpack_require__(80);
	
	var _InfoSection = __webpack_require__(57);
	
	var _Signup = __webpack_require__(293);
	
	var _FeaturedArtists = __webpack_require__(105);
	
	var _ArtistGrid = __webpack_require__(103);
	
	var _OverviewBlocks = __webpack_require__(107);
	
	var _LinkBox = __webpack_require__(38);
	
	var _AuditionExcerpts = __webpack_require__(278);
	
	var _logo_color = __webpack_require__(100);
	
	var _logo_color2 = _interopRequireDefault(_logo_color);
	
	__webpack_require__(428);
	
	var _dataEn = __webpack_require__(39);
	
	var _dataEn2 = _interopRequireDefault(_dataEn);
	
	var _dataCn = __webpack_require__(58);
	
	var _dataCn2 = _interopRequireDefault(_dataCn);
	
	var _locale = __webpack_require__(28);
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var data = { en: _dataEn2.default, cn: _dataCn2.default };
	var localizedData = function localizedData() {
	  return data[_locale2.default.getLocale()];
	};
	var chamber_series_page = localizedData().chamber_series_page;
	
	var ChamberSeriesPage = function (_Component) {
	  _inherits(ChamberSeriesPage, _Component);
	
	  function ChamberSeriesPage() {
	    _classCallCheck(this, ChamberSeriesPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ChamberSeriesPage.prototype.render = function render() {
	
	    var overviewSizes = [this.props.data.trainingResidencyImage.sizes, this.props.data.concertTourImage.sizes];
	
	    var teachingArtistSizes = [this.props.data.qingLiImage.sizes, this.props.data.yongMaImage.sizes, this.props.data.guangChenImage.sizes];
	
	    var studentArtistSizes = [this.props.data.yuboCaoImage.sizes, this.props.data.yiqingFuImage.sizes, this.props.data.hankeLiImage.sizes, this.props.data.yixiangWangImage.sizes, this.props.data.junyiLiImage.sizes, this.props.data.yujieZengImage.sizes, this.props.data.zhihongLiImage.sizes, this.props.data.tianchengZhuImage.sizes, this.props.data.yaxinDangImage.sizes, this.props.data.zishuXieImage.sizes, this.props.data.ningZhangImage.sizes, this.props.data.huibinZouImage.sizes, this.props.data.jingrenChengImage.sizes, this.props.data.yichuanWangImage.sizes, this.props.data.jingyanWangImage.sizes, this.props.data.yichengGongImage.sizes, this.props.data.jihanZhangImage.sizes, this.props.data.zhaotingLiuImage.sizes, this.props.data.tianqiWuImage.sizes, this.props.data.puyuanChenImage.sizes, this.props.data.zhouDiImage.sizes];
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Header.Header, { src: _logo_color2.default, data: localizedData().header }),
	      _react2.default.createElement(
	        'div',
	        { className: 'margin-large' },
	        _react2.default.createElement(_InfoSection.InfoSection, {
	          title: chamber_series_page.overview.title,
	          description: chamber_series_page.overview.description,
	          sizes: this.props.data.chamberSeriesImage.sizes }),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_OverviewBlocks.OverviewBlocks, {
	          blocks: chamber_series_page.overview_blocks,
	          sizes: overviewSizes }),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(_FeaturedArtists.FeaturedArtists, {
	          data: chamber_series_page.teaching_artists,
	          sizes: teachingArtistSizes }),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(_ArtistGrid.ArtistGrid, {
	          data: chamber_series_page.student_artists,
	          sizes: studentArtistSizes,
	          isShort: true })
	      ),
	      _react2.default.createElement(_Footer.Footer, null)
	    );
	  };
	
	  return ChamberSeriesPage;
	}(_react.Component);
	
	exports.default = ChamberSeriesPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-2018-chamber-series-jsx-003df70848c8396680f6.js